import { createFileRoute, useParams } from '@tanstack/react-router';

import { CourseDetailLayout } from '@/views/courses/detail/course-layout.tsx';

// Course-detail layout route. The `courses_` segment opts OUT of nesting under the
// /courses list (which has no <Outlet/>), so this renders standalone under the
// _learner shell and provides its own <Outlet/> for the tab children.
export const Route = createFileRoute('/_learner/courses_/$id')({
  component: CourseDetailRoute,
});

function CourseDetailRoute() {
  const { id } = useParams({ from: '/_learner/courses_/$id' });
  return <CourseDetailLayout id={id} />;
}
